import { render, staticRenderFns } from "./ArchivedActivities.vue?vue&type=template&id=070c96a0&scoped=true&"
import script from "./ArchivedActivities.vue?vue&type=script&lang=js&"
export * from "./ArchivedActivities.vue?vue&type=script&lang=js&"
import style0 from "./ArchivedActivities.vue?vue&type=style&index=0&id=070c96a0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070c96a0",
  null
  
)

export default component.exports